import emojiRegex from "emoji-regex" // npm install emoji-regex
export default {
  name: "clearEmoij",
  bind: function (el, binding, vnode, oldVnode) {
    const regex = emojiRegex()
    const obj = el.querySelectorAll(".el-input__inner,.el-textarea__inner")[0]
    const zclearNoNum = function (e) {
      if (e.target.composing) return
      const match = regex.exec(obj.value) // 也可以直接用正则表达式判断
      if (match) {
        /* for (let i=0;i<match.length;i++) {
          obj.value = obj.value.replace(match[i],"");
        }*/
        obj.value = obj.value.replace(
          /[\u{1F300}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}]/gu,
          ""
        )
        zclearNoNum(e)
      }
      // 触发v-model的更新
      obj.dispatchEvent(new Event("input"))
    }
    const zblur = function (e) {
      zclearNoNum(e)
      setTimeout(() => {
        const match = regex.exec(obj.value)
        if (match) {
          obj.value = obj.value.replace(
            /[\u{1F300}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}]/gu,
            ""
          )
          zclearNoNum(e)
        }
        // 触发v-model的更新
        obj.dispatchEvent(new Event("change"))
      }, 50)
    }
    obj.onkeyup = zclearNoNum
    obj.onblur = zblur

    function onCompositionStart(e) {
      e.target.composing = true
    }
    function onCompositionEnd(e) {
      console.log("按回车将字输入", e.target.value)
      e.target.composing = false
      obj.dispatchEvent(new Event("change"))
      setTimeout(() => {
        if (obj.value) {
          obj.value = obj.value.replace(
            /[\u{1F300}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}]/gu,
            ""
          )
          zclearNoNum(e)
        }
        // 触发v-model的更新
        obj.dispatchEvent(new Event("change"))
      }, 50)
    }
    obj.addEventListener("compositionstart", onCompositionStart)
    obj.addEventListener("compositionend", onCompositionEnd)
  }
}
